import './sentry';
import React from 'react';

window.addEventListener('vite:preloadError', () => {
  const key = 'vite-preload-reload-ts';
  const last = Number(sessionStorage.getItem(key) ?? 0);
  if (Date.now() - last > 10_000) {
    sessionStorage.setItem(key, String(Date.now()));
    window.location.reload();
  }
});
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import './i18n';

// React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 3,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="bottom-right"
        containerStyle={{ zIndex: 'var(--z-toast)' }}
        toastOptions={{
          duration: 3000,
          style: {
            fontWeight: 500,
          },
          success: {
            style: {
              background: '#16a34a',
              color: '#fff',
              border: 'none',
            },
            iconTheme: { primary: '#fff', secondary: '#16a34a' },
          },
          error: {
            style: {
              background: '#dc2626',
              color: '#fff',
              border: 'none',
            },
            iconTheme: { primary: '#fff', secondary: '#dc2626' },
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>
);
